<template>
    <div>
        <input v-if="name !== undefined" type="hidden" :name="name" :value="(value === null) ? '' : value.id" />

        <v-select
            :options="options"
            :placeholder="placeholder"
            v-on:search="search"
            v-model="value"
            label="text"
        />
    </div>
</template>

<script>
import axios from 'axios';
import VSelect from 'vue-select';

const CancelToken = axios.CancelToken;

import { debounce } from 'lodash';

export default {
    components: {
        VSelect,
    },
    props: {
        name: String,
        placeholder: String,
        route: String,
    },
    data () {
        return {
            options: [],
            request: null,
            value: null,
        }
    },
    created () {
        // "dereference" the debounced function by
        // not debouncing in function definition
        this.search = debounce(this.search, 350);
    },
    mounted () {
        // initialise list
        this.search();
    },
    watch: {
        value () {
            this.$emit('update:model-value', this.value);
        },
    },
    methods: {
        search: async function (searchTerm, loading) {
            loading = loading || function () {};

            this.options = [];
            loading(true);

            if (this.request !== null) {
                this.request.cancel('Operation canceled by the user.');
            }
            this.request = CancelToken.source();

            try {
                const response = await axios.get(this.route, {
                    params: {
                        search: searchTerm,
                    },
                    cancelToken: this.request.token,
                });

                this.options = response.data.data;
            } catch (err) {
                console.error(err);
            } finally {
                loading(false);
            }
        },
    },
};
</script>
